<template>
    <div>
        <card title="Unidades de Negocio" icon="fas fa-city">
            <master-options @showModal="showModal" :links="links" @index="index" @reset="reset"></master-options>
            <div class="table-responsive">
                <manage-table :hover="true" :headers="['Id', 'Nombre', 'Centros de Costo']" :hasOptions="true">
                    <tr v-for="bu in ListBusinessUnits" :key="bu.id">
                        <td style="width: 5%;">{{ bu.id }}</td>
                        <td>{{ bu.name }}</td>
                        <td style="width: 30%;">
                            <div class="row">
                                <div class="col-md-4">
                                    Cantidad: <span class="badge badge-success">{{ bu.costCenterCount }}</span>
                                </div>
                                <div class="col-md-8 text-right">
                                    <a class="btn btn-sm btn-primary"
                                        tittle="Ver Centros de Costo asociados a la Unidad de Negocio"
                                        :href="getHrefCostCenter(bu.name)">Ver Centros de Costos</a>
                                    <button class="btn btn-sm btn-success ml-2"
                                        @click="showMassiveCostCenterUpdateModal(bu)">Actualización
                                        Masiva</button>
                                </div>
                            </div>
                        </td>
                        <td>
                            <button class="btn btn-info btn-sm mr-2" @click="showModal(bu)" data-toggle="tooltip"
                                data-placement="top" title="Editar Unidad de Negocio">
                                <i class="fas fa-edit"></i>
                            </button>
                            <button title="Eliminar Unidad de Negocio" class="btn btn-danger btn-sm "
                                @click="deleteBusinessUnits(bu.id, bu.name)" data-toggle="tooltip" data-placement="top">
                                <i class="fas fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </manage-table>
            </div>
            <paginator class="mt-4" :links="links"></paginator>
        </card>
        <modal id="businessUnitsFormModal" :title="modalTitle" @modalClose="index">
            <business-units-form :bUnits="bUnits" @pressOk="save"></business-units-form>
        </modal>

        <modal id="showMassiveCostCenterUpdateModal" :title="'Actualización de Centro de Costos'"
            @modalClose="index">
            <massive-costenter-update :bUnits="bUnits" @updateDone="hideMassiveCostCenterUpdateModal"></massive-costenter-update>
        </modal>
    </div>
</template>

<script>
import { Get, Delete, Post, Put } from "../../helper/axios.js";
import Card from "../../components/Card.vue";
import $ from "jquery";
import { getUrlQuery } from "../../helper/queryHelper";
export default {
    components: {
        Card
    },
    data() {
        return {
            ListBusinessUnits: [],
            Post,
            Delete,
            apiUrl: this.$store.getters.apiUrl,
            modalTitle: '',
            Get,
            Put,
            bUnits: {},
            links: {},
            getUrlQuery
        };
    },
    watch: {
        urlQuery: function () {
            this.index()
        }
    },
    created() {
        this.index();
    },
    methods: {
        index() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/businessunits?" + this.urlQuery, res => {
                this.ListBusinessUnits = res.data.data;
                this.links = res.data.links;
                this.$store.commit("setLoading", false);
            });
        },
        reset() {
            this.links = {}
            this.index()
        },
        save() {
            if (this.bUnits.id)
                this.update()
            else
                this.store()

        },
        showModal(bUnits) {
            if (bUnits && bUnits.id) {
                this.modalTitle = "Actualizar Unidad de Negocio";
                this.bUnits = bUnits;
            } else {
                this.modalTitle = "Crear Unidad de Negocio";
                this.bUnits = {};
            }
            $('#businessUnitsFormModal').modal('show');
        },
        showMassiveCostCenterUpdateModal(bUnits) {
            if (bUnits) {
                this.bUnits = bUnits
                $('#showMassiveCostCenterUpdateModal').modal('show');
            }

        },
        hideMassiveCostCenterUpdateModal() {
            $('#showMassiveCostCenterUpdateModal').modal('hide');
            this.index();
        },
        deleteBusinessUnits(id, name) {
            this.$swal({
                title: `¿Desea eliminar la Unidad de Negocio ${name}?`,
                text: "También se eliminarán los centros de costos asociados",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33"
            }).then(result => {
                if (result.value) {
                    this.Delete(this.apiUrl + 'v1/businessunits/' + id, () => {
                        window.toastr.success('Unidad de Negocio Eliminado correctamente.');
                        this.index();
                    });
                }

            });
        },
        update() {
            this.$store.commit("setLoading", true);
            this.Put(this.apiUrl + "v1/businessunits/" + this.bUnits.id, this.bUnits, () => {
                $('#businessUnitsFormModal').modal('hide');
                this.$store.commit("setLoading", false);
                window.toastr.success('Unidad de Negocio Actualizado correctamente.');
                this.reset();
            });
            //validar el put para ejecutar lo de abajo

        },
        store() {
            this.$store.commit("setLoading", true);
            this.Post(`${this.apiUrl}v1/businessunits/`, this.bUnits, () => {
                $('#businessUnitsFormModal').modal('hide');
                this.$store.commit("setLoading", false);
                window.toastr.success('Unidad de Negocio Registrado correctamente.');
                this.bUnits = {};
                this.reset();
            });
        },
        getHrefCostCenter(name) {
            return "/costcenters?search=" + name;
        }
    },
    computed: {
        urlQuery() {
            return this.getUrlQuery()
        }
    }

}

</script>